












































































import { PropType } from 'vue';
import { mapState } from 'vuex';
import { roundNumber } from '@/helpers/roundNumber';
import type { BlockchainWalletItem } from '@/api/schema';

export default {
  name: 'TokenManagementBalanceWallet',
  props: {
    wallets: {
      type: Array as PropType<BlockchainWalletItem[]>,
      default: (): [] => [],
      required: true
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    errorMessage: {
      type: String as PropType<string>,
      default: (): string => ''
    }
  },
  computed: {
    ...mapState('Auth', ['tokenSymbol'])
  },
  methods: {
    roundNumber
  }
};
